<template>
  <ZtLink class="teaser is-half group-link" :to="url">
    <div class="teaser-media">
      <slot name="media">
        <div
          v-blokkli-droppable:[editableConfig?.image]
          class="image aspect-4/3"
        >
          <MediaImage v-bind="media" responsive-style="column_half" />
        </div>
      </slot>
    </div>
    <h2
      v-blokkli-editable:[editableConfig?.title]
      class="title is-h4"
      v-html="title"
    />
    <div
      v-blokkli-editable:[editableConfig?.tagline]
      class="subtitle is-h5 mb-0"
      v-html="tagline"
    />
    <slot />

    <p
      v-blokkli-editable:[editableConfig?.text]
      class="teaser-text text-prose"
      v-html="text"
    />
    <div
      v-blokkli-editable:[editableConfig?.linkTitle]
      class="link with-arrow"
      v-html="linkTitle || $texts('teaserMore')"
    />
  </ZtLink>
</template>

<script lang="ts" setup>
import type { TeaserProps } from './types'

defineProps<TeaserProps>()
</script>

<style lang="postcss">
.teaser.is-half {
  @apply tablet:flex tablet:h-full tablet:flex-col;

  .title {
    @apply mb-0 mt-size-5;
  }
  .teaser-text {
    @apply mb-size-6;
  }

  .link {
    @apply mt-auto text-size-6;
    @apply desktop:text-size-5;
  }
}
</style>
